/*
Descrição..........: Service que exibe a mensagem de sucesso, ou erro, ao executar alguma função
Autor..............: Pablo Ebbers
Data Criação.......: 01/03/2020
Última Atualização.: 17/03/2020

Funções/Métodos:
-----
async showConfirmDelete(name: string, actionRemove: () => void) retorno: Notificação Personalizada
Método para criar e exibir a caixa de diálogo antes de alguma exclusão
-----
showSucess/showError(message: string): retorno: envio de dados para a função principal
-----
private async show(message: string, color: string, header: string) retorno: caixa de notificação sobre o resultado da requisição
Cria e exibe uma caixinha personalizada indicando o resultado de uma função (erro ou sucesso)
-----
*/
import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService2 {

  constructor(private toast: ToastController) { }

showSucess(message: string) {
  this.show(message, 'warning', 'Sucesso');
}

showError(message: string) {
  this.show(message, 'danger', 'Erro');
}

  private async show(message: string, color: string, header: string) {
    const toast = await this.toast.create({
      // tslint:disable-next-line: object-literal-shorthand
      header: header,
      // tslint:disable-next-line: object-literal-shorthand
      message: message,
      // tslint:disable-next-line: object-literal-shorthand
      color: color,
      position: 'bottom',
      duration: 5000
    });
    toast.present();
  }


  async presentToast() {
    const toast = await this.toast.create({
      message: 'Your settings have been saved.',
      duration: 2000
    });
    toast.present();
  }

  async presentToastWithOptions() {
    const toast = await this.toast.create({
      header: 'Toast header',
      message: 'Click to Close',
      position: 'top',
      buttons: [
        {
          side: 'start',
          icon: 'star',
          text: 'Favorite',
          handler: () => {
            console.log('Favorite clicked');
          }
        }, {
          text: 'Done',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    toast.present();
  }


}
